<template>
 
  <div class="result-item" v-for="(job, index) in preJobs" :key="index" @click="showDetail(job.id)">
    <div class="job-application-status" :class="getClass(job.status)" v-if="job.status != ''">{{ job.status }}</div>
    <div class="job-image-title">
      <div class="image_wrapper" data-testid="directions-61" @click="userInfoModalPreOpen(job.jobPharmacy)">
        <el-avatar :size="'small'" shape="square" :src="job.image" v-if="job.image" />
        <el-avatar :size="'small'" class="avatar-job" shape="square"
          icon="locumate_icons locumate_icon-user1 locumate_icons-avatar" v-else></el-avatar>
      </div>
      <div class="job-detail-main">
        <div class="job-title">{{ job.title }}</div>
        <div class="job-poster">{{ job.poster }}</div>
      </div>
      <el-tag class="inverted job-type-tag" :class="job.type">
        {{ job.type }}
      </el-tag>
    </div>
    <div class="job-detail-row-item">
      <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M9.9999 11.1917C11.4358 11.1917 12.5999 10.0276 12.5999 8.5917C12.5999 7.15576 11.4358 5.9917 9.9999 5.9917C8.56396 5.9917 7.3999 7.15576 7.3999 8.5917C7.3999 10.0276 8.56396 11.1917 9.9999 11.1917Z"
          stroke="rgb(var(--locumate-primary-color))" stroke-width="1.5" />
        <path
          d="M3.01675 7.07484C4.65842 -0.141827 15.3501 -0.133494 16.9834 7.08317C17.9418 11.3165 15.3084 14.8998 13.0001 17.1165C11.3251 18.7332 8.67508 18.7332 6.99175 17.1165C4.69175 14.8998 2.05842 11.3082 3.01675 7.07484Z"
          stroke="rgb(var(--locumate-primary-color))" stroke-width="1.5" />
      </svg>
      <div class="job-detail-text">
        {{ job.location }}
      </div>
    </div>

    <div class="job-extra-info">
      <el-tag class="inverted">
        <span>Applied {{ job.applied }}</span>
      </el-tag>
    </div>
  </div>
  <modal-user-pre-info :modalName="'userPreInfoModal'" :options="userPreInfoModal"></modal-user-pre-info>
</template>
  
  <script>
import { inject, ref } from "vue";
import {
    useRouter,
} from "vue-router";
import { PharmacyInfoModal } from "@/modals/modals";
export default {
  props: {
    preJobs: {
      type: Object,
      required: true,
    },
  },
  components: {
    "modal-user-pre-info": PharmacyInfoModal,
  },
  setup() {
    const $router = useRouter();
    const $modals = inject("$modals");
    const userPreInfoModal = ref({
      name: "userInfo",
      user: {},
    });const userInfoModalPreOpen = (user) => {
      if (user) {
        userPreInfoModal.value.user = user;
      }
      $modals.open("userPreInfoModal");
    };
    // const job = ref(props.job);
    const profileImage = "@/assets/img/job-seeker/profile.svg"; // Assuming this path is correct

    const showDetail = (jobId) => {
    console.log("🚀 ~ showDetail ~ jobId:", jobId)

      $router.push({
        name: "job_seeker_previous_application",
        params: { jobId: jobId } // Assuming job object has an 'id' property
      });
    };

    const goBack = () => {
           
            $router.push({
                name: "job_seeker_applications",
            });
        };

      const getClass = (status) => {
      const lowercaseStatus = status.toLowerCase();
     return lowercaseStatus;
    };

    
    return {  profileImage, showDetail,goBack,getClass,userPreInfoModal,
      userInfoModalPreOpen, };
  }
}
</script>